<script>
</script>

<div class="mx-8">
    <div class="flex md:flex-row p-2 flex-col w-full md:h-[300px]">
        <div class="flex justify-center items-center md:w-full">
            <p class="text-black dark:text-white text-sm overflow-hidden">
                &emsp &emsp I have a Bachelors degree in Computer Science and
                have worked as a Software Engineer for several years. I was
                introduced to CS from the game Minecraft. I put too many hours
                of my life into that game and eventually wanted to know how the
                game worked under the hood. I took my first programming class in
                my Freshman year of highschool working in Visual Basic. My
                curiosity had been peaked and I needed more. I took a
                programming course each year in highschool, working with
                languages like C, C++, Java and C#. Programming became my
                passion so, naturally, I made it my focus throughout college. I
                am currently working on plenty of side projects in different
                languages...mainly Rust at the time of writing this. The link to
                those projects is down below titled Gitlab as well as links to
                my Youtube and Twitch pages. I hope you enjoy my blog and have a
                wonderful day!
            </p>
        </div>
    </div>

    <div class="w-full h-[1px] bg-gray-800 dark:bg-gray-100 my-2" />

    <div class="flex flex-row md:justify-center justify-between md:flex-row">
        <a
            href="https://gitlab.com/jchand99"
            class="px-6 py-2 text-2xl font-bold text-black cursor-pointer rounded-md dark:text-white hover:bg-gray-200 dark:hover:bg-gray-600"
            ><i class="lab la-gitlab text-orange-500" /></a
        >
        <a
            href="https://www.youtube.com/channel/UCfcij6KxJV4d-tMzXCBdyLg"
            class="px-6 py-2 text-2xl font-bold text-black cursor-pointer rounded-md dark:text-white hover:bg-gray-200 dark:hover:bg-gray-600"
            ><i class="lab la-youtube text-red-500" /></a
        >
        <a
            href="https://www.twitch.tv/qubyts"
            class="px-6 py-2 text-2xl font-bold text-black cursor-pointer rounded-md dark:text-white hover:bg-gray-200 dark:hover:bg-gray-600"
            ><i class="lab la-twitch text-purple-500" /></a
        >
    </div>
</div>
